import { render, staticRenderFns } from "./notificationBanner.vue?vue&type=template&id=3cd8faf2&scoped=true&"
import script from "./notificationBanner.vue?vue&type=script&lang=js&"
export * from "./notificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./notificationBanner.vue?vue&type=style&index=0&id=3cd8faf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd8faf2",
  null
  
)

export default component.exports